export default __webpack_public_path__ + "static/media/chevron-right.00470e5b.svg";